//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import {
  postFakeLogin,
} from "../../../helpers/fakebackend_helper";
import { toast } from 'react-toastify';
import { saveAuthUser, clearAuthUser } from "../../../helpers/tokenHelper";

import { loginSuccess, logoutUserSuccess, apiError, reset_login_flag } from './reducer';

export const loginUser = (user : any, history : any, returnUrl?: string) => async (dispatch : any) => {
    postFakeLogin({
        userName: user.userName,
        password: user.password,
        tenant: user.tenant  // ADDED
    }).then((res : any) => {
      if (res) {
        // Lưu với loginTime để track token expiration
        saveAuthUser(res);
        dispatch(loginSuccess(res));
        // Nếu người dùng bị redirect tới /login từ một trang yêu cầu đăng nhập
        // (AuthProtected lưu lại state.from) thì quay lại đúng trang đó, ngược lại về /dashboard
        history(returnUrl || '/dashboard');
      }
        }).catch((error : any) => {
      const errorMessage = error.message || 'Login Failed';
      toast.error(errorMessage, { autoClose: 3000 });
      console.log("Error:", error);
      // Dispatch serializable error message instead of Error object
      dispatch(apiError(errorMessage));
    });
};

export const logoutUser = () => async (dispatch : any) => {
  try {
    // Xóa auth data bằng helper function
    clearAuthUser();
    
    let fireBaseBackend : any = getFirebaseBackend();
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = fireBaseBackend.logout;
      dispatch(logoutUserSuccess(response));
    } else {
      dispatch(logoutUserSuccess(true));
    }

  } catch (error: any) {
    const errorMessage = error?.message || 'Logout failed';
    dispatch(apiError(errorMessage));
  }
};

export const socialLogin = (type : any, history : any, returnUrl?: string) => async (dispatch : any) => {
  try {
    let response;

    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const fireBaseBackend : any = getFirebaseBackend();
      response = fireBaseBackend.socialLoginUser(type);
    }
    //  else {
      //   response = postSocialLogin(data);
      // }

      const socialdata = await response;
    if (socialdata) {
      // Lưu với loginTime để track token expiration
      saveAuthUser(response);
      dispatch(loginSuccess(response));
      history(returnUrl || '/dashboard');
    }

  } catch (error: any) {
    const errorMessage = error?.message || 'Social login failed';
    dispatch(apiError(errorMessage));
  }
};

export const resetLoginFlag = () => async (dispatch : any) => {
  try {
    const response = dispatch(reset_login_flag());
    return response;
  } catch (error: any) {
    const errorMessage = error?.message || 'Reset login flag failed';
    dispatch(apiError(errorMessage));
  }
};